var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef, useState } from 'react';
import apiClient from '@utils/api-client';
const POLL_INTERVAL_MS = 30000;
const useGetIntegrationStatus = (integration) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const intervalRef = useRef(null);
    const fetchStatus = (signal) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield apiClient.get('/integration_statuses', {
                params: { integration },
                signal
            });
            setData(response.data);
            setError(null);
        }
        catch (err) {
            if (!signal.aborted) {
                setError('Failed to load integration status');
            }
        }
        finally {
            if (!signal.aborted) {
                setLoading(false);
            }
        }
    });
    useEffect(() => {
        const controller = new AbortController();
        void fetchStatus(controller.signal);
        intervalRef.current = setInterval(() => {
            void fetchStatus(controller.signal);
        }, POLL_INTERVAL_MS);
        return () => {
            controller.abort();
            if (intervalRef.current !== null) {
                clearInterval(intervalRef.current);
            }
        };
    }, [integration]);
    return { data, loading, error };
};
export default useGetIntegrationStatus;
